module.exports = __webpack_public_path__ + "img/Logo-3.807d2a2c.svg";